
export * from '../../frontend-taglib-clay/__liferay__/exports/@clayui$table.js';

import __default__ from '../../frontend-taglib-clay/__liferay__/exports/@clayui$table.js';
export default __default__;
